export default __webpack_public_path__ + "static/media/G0720.34I-26450_-16302_0.1666268160000.a4519a60.jpg";